import {
  getMobileDeviceType,
  isMobile
} from "features/common/utils/functions/mobile";
import { useIsFirstSession } from "features/user/hooks/useIsFirstSession";

import { usePushToDataLayer } from "./scopes/global";
import { usePushToDataLayerUserScope } from "./scopes/user";
import { usePushUserPropertiesToDataLayer } from "./scopes/userProperties";

export function useGlobalDataLayerValues() {
  useStaticDeviceDataLayer();
  useUserPropertiesDataLayer();
  useIsFirstSessionDataLayer();
}

function useIsFirstSessionDataLayer() {
  const [isFirstSession] = useIsFirstSession();
  usePushToDataLayerUserScope("isFirstUserSession", isFirstSession);
}

function useStaticDeviceDataLayer() {
  usePushToDataLayer("appVersion", import.meta.env.VITE_APP_VERSION);
  usePushToDataLayer("isMobile", isMobile());
  usePushToDataLayer("mobileDeviceType", getMobileDeviceType());
}

function useUserPropertiesDataLayer() {
  usePushUserPropertiesToDataLayer(
    "appVersion",
    import.meta.env.VITE_APP_VERSION
  );
}
